import { deviceIsMobile } from '@/utils/device-utils';

export default function ({ store }) {
  if (process.client) {
    // 初始化时判断是否为移动设备
    store.commit('setIsMobile', deviceIsMobile());

    // 监听屏幕尺寸变化
    window.addEventListener('resize', () => {
      store.commit('setIsMobile', deviceIsMobile());
    });
  }
}
